// Empty module used as a polyfill placeholder for Node.js modules
export default {};
